import React, { FC } from 'react';
import { Button } from '@cokitchen/cokitchen-components';

type RecordPaymentFooterProps = {
  onCancel: () => void;
  loading: boolean;
  onConfirm: () => void;
  disabled?: any;
};

export const RecordPaymentFooter: FC<RecordPaymentFooterProps> = ({
  onConfirm,
  loading,
  disabled
}) => (
  <div>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}
      disabled={disabled}>
      Confirm
    </Button>
  </div>
);
